export var GetPaymentInstrumentsResponse;
(function (GetPaymentInstrumentsResponse) {
    GetPaymentInstrumentsResponse.LastUsedPaymentTypeEnum = {
        CreditCard: 'CreditCard',
        DirectDebit: 'DirectDebit',
        ERV: 'ERV'
    };
})(GetPaymentInstrumentsResponse || (GetPaymentInstrumentsResponse = {}));
